
import '../styles/LoginPage.css';
import topImage from "../assets/logocl.png";
import bgVideo from "../assets/bluegrad.mp4";
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';


export default function Auth({ setUser }) {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);           // Loading state
  const [errorMessage, setErrorMessage] = useState('');        // Error message state

  // After Flask redirects back from /auth/callback → /dashboard,
  // your React app should be mounted on /dashboard (or whatever route)
  // and you can fetch the current_user.
  useEffect(() => {
    // Try to load the logged‑in user
    fetch('/api/current_user', {//api
      credentials: 'include',    // send HttpOnly cookie
    })
      .then(res => {
        if (!res.ok) throw new Error('Not logged in');
        return res.json();
      })
      .then(user => {
        setUser(user);
        if (user.role === 'Viewer') {
          navigate('/loading'); // Redirect to new loading screen
        } else {
          navigate('/home'); // Default redirect
        }

      })

      .catch(() => {
        // not logged in yet — stay on login screen
      });
  }, [navigate, setUser]);

  const handleLogin = () => {
    // Kick off the flow entirely on the backend
    setIsLoading(true);
    setErrorMessage('');
    try {
      // Redirect to backend login
      window.location.href = '/api/auth/login';
    } catch (err) {
      setIsLoading(false);
      setErrorMessage('Something went wrong. Please try again.');
    }
  };




  return (
    <div className="login-bg">
      <video autoPlay muted loop playsInline>
        <source src={bgVideo} type="video/mp4" />
      </video>

      <div className="login-card">
        {/* Logo on top */}
        <img src={topImage} alt="Logo" className="top-icon" />

        <h2>Let's Sign you in!</h2>

        <button
          className="google-btn"
          onClick={handleLogin}
           style={{ color: 'black' }}
        >
          <img
            src="https://developers.google.com/identity/images/g-logo.png"
            alt="Google"
            style={{ width: '18px', marginRight: '10px' }}
          />
          Continue with Google
        </button>


        {/* Terms and Conditions text */}
        <p className="terms-text">
          By continuing, you agree to our <a href="#">Terms & Conditions</a>.
        </p>
      </div>

    </div>
  );
} 